<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-update-profile-button/user-update-profile-button.ts.UserUpdateProfileButtonComponent.html